"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrNewsletterForm = exports.FdrNewsletterFormValidationSchema = void 0;
const formik_1 = require("formik");
const next_i18next_1 = require("next-i18next");
const react_1 = __importStar(require("react"));
const Yup = __importStar(require("yup"));
const components_common_radio_group_1 = require("@hotelplan/components.common.radio-group");
const components_common_text_input_1 = require("@hotelplan/components.common.text-input");
const core_basis_bs_button_1 = require("@hotelplan/core.basis.bs-button");
const libs_utils_1 = require("@hotelplan/libs.utils");
const supergraph_api_1 = require("@hotelplan/supergraph-api");
const fdr_newsletter_form_styles_1 = require("./fdr-newsletter-form.styles");
exports.FdrNewsletterFormValidationSchema = Yup.object({
    salutation: Yup.string()
        .required('forms:errors.required')
        .oneOf(Object.values(supergraph_api_1.FdrSalutation)),
    firstName: Yup.string()
        .min(2, 'forms:errors.firstName.tooShort')
        .max(50, 'forms:errors.firstName.tooLong')
        .matches(libs_utils_1.NAME_REGEX, 'forms:errors.name.lettersOnly')
        .required('forms:errors.required'),
    lastName: Yup.string()
        .min(2, 'forms:errors.lastName.tooShort')
        .max(50, 'forms:errors.lastName.tooLong')
        .matches(libs_utils_1.NAME_REGEX, 'forms:errors.name.lettersOnly')
        .required('forms:errors.required'),
    email: Yup.string()
        .email('forms:errors.email.invalid')
        .matches(/\.[a-z]{2,}$/i, 'forms:errors.email.invalid')
        .required('forms:errors.required'),
});
const FdrNewsletterForm = ({ onSubmit, errorNotification, initialValues, formDescription, }) => {
    const [t] = (0, next_i18next_1.useTranslation)(['forms', 'newsletter']);
    const options = [
        { value: supergraph_api_1.FdrSalutation.Mr, content: t('forms:gender.options.male') },
        { value: supergraph_api_1.FdrSalutation.Ms, content: t('forms:gender.options.female') },
    ];
    const formInitialValues = (0, react_1.useMemo)(() => {
        if (!initialValues) {
            return {
                salutation: undefined,
                firstName: '',
                lastName: '',
                email: '',
            };
        }
        return initialValues;
    }, [initialValues]);
    return (react_1.default.createElement(formik_1.Formik, { initialValues: formInitialValues, enableReinitialize: true, onSubmit: onSubmit, validationSchema: exports.FdrNewsletterFormValidationSchema }, formik => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            errorNotification ? react_1.default.createElement(react_1.default.Fragment, null, errorNotification) : null,
            react_1.default.createElement(fdr_newsletter_form_styles_1.FdrEmailNewsletterForm, { noValidate: true, onSubmit: (e) => formik.handleSubmit(e) },
                react_1.default.createElement(components_common_radio_group_1.ValidatedRadioGroup, { required: true, options: options, name: 'salutation', label: t('forms:gender.label'), className: "radio-group-input", error: formik.errors.salutation ? t(formik.errors.salutation) : null }),
                react_1.default.createElement(fdr_newsletter_form_styles_1.FdrNameWrapper, null,
                    react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { required: true, name: "firstName", label: t('forms:firstName.label'), className: "text-input first-name-input", placeholder: t('forms:firstName.placeholder') }),
                    react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { required: true, name: "lastName", label: t('forms:lastName.label'), className: "text-input last-name-input", placeholder: t('forms:lastName.placeholder') })),
                react_1.default.createElement(components_common_text_input_1.ValidatedTextInput, { required: true, name: "email", type: "email", label: t('forms:email.label'), className: "text-input", placeholder: t('forms:email.placeholder') }),
                formDescription || null,
                react_1.default.createElement(fdr_newsletter_form_styles_1.FdrSubmitButtonWrapper, null,
                    react_1.default.createElement(core_basis_bs_button_1.BsButton, { disabled: formik.isSubmitting, className: "form-submit-button", type: "submit" }, t('forms:submit.button'))))));
    }));
};
exports.FdrNewsletterForm = FdrNewsletterForm;
//# sourceMappingURL=fdr-newsletter-form.js.map